<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section">
      <div class="o-wrapper">
        <input type="hidden" name="action" value="freeform/api/form">
        <div class="c-section__header">
          <h2 class="c-section__heading u-h3 u-600">General Enquiries</h2>
        </div>
        <form method="post" accept-charset="UTF-8" class="u-4/7@desktop" @submit.prevent="postForm" v-if="!formSubmitted">
          <div class="u-mb">
            <input class="c-form-input" type="text" placeholder="First name*" required v-model="form.name.first">
          </div>
          <div class="u-mb">
            <input class="c-form-input" type="text" placeholder="Last name*" required v-model="form.name.last">
          </div>
          <div class="u-mb">
            <input class="c-form-input" type="email" placeholder="Email address*" required v-model="form.email">
          </div>
          <div class="u-mb">
            <input class="c-form-input" type="text" placeholder="Phone number*" required  v-model="form.phone">
          </div>
          <div class="u-mb">
            <textarea class="c-form-input c-form-input--message" placeholder="Message*" required  v-model="form.message"></textarea>
          </div>
          <div class="u-mb+-">
            <div class="c-form-checkbox">
              <div class="c-form-checkbox__input">
                <label class="c-custom-checkbox">
                  <input class="c-custom-checkbox__input" type="checkbox" :true-value="'yes'" :false-value="''" v-model="form.receiveNewsletter">
                  <span class="c-custom-checkbox__replacement"></span>
                </label>
              </div>
              <label class="u-hl-blue-royal u-300" for="">Yes, I would like to receive newsletter updates regarding the Taiko Trust</label>
            </div>
          </div>
          <div>
            <button class="c-btn c-btn--quinary" type="submit">Submit</button>
          </div>
        </form>
        <p v-else>Thanks! We'll be in touch.</p>
      </div>
      <hr class="u-hr-grey u-mt+ u-mb+">

      <div class="o-wrapper">
        <div class="c-panel c-panel--secondary c-panel--large">
          <div class="c-panel__content">
            <div class="c-panel__figure c-panel__figure--map">
              <google-map />
            </div>
            <div class="c-panel__body">
              <div class="c-panel__arrow" v-if="hasArrow">
                <img src="@/assets/arrow-right-blue.svg" width="45" alt="Right arrow">
              </div>
              <div class="u-mb" v-if="globalContact.postalAddress">
                <h5 class="c-panel__heading u-h6">Postal Address</h5>
                <div class="o-box-off">
                  <p>
                    <span v-for="line in globalContact.postalAddress.split('\n')" :key="line.id">{{ line }}<br></span>
                  </p>
                </div>
              </div>
              <div v-if="globalContact.emailAddress">
                <h5 class="c-panel__heading u-h6">Email</h5>
                <div class="o-box-off">
                  <p><a :href="'mailto:' + globalContact.emailAddress">{{ globalContact.emailAddress }}</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import Hero from '@/components/Hero.vue'
import GoogleMap from '@/components/GoogleMap.vue'

export default {
  name: 'Contact',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    GoogleMap: GoogleMap
  },
  data () {
    return {
      title: '',
      entry: null,
      globalContact: null,
      formSubmitted: false,
      form: {
        handle: 'contact',
        name: {
          first: '',
          last: ''
        },
        email: '',
        phone: '',
        message: '',
        receiveNewsletter: ''
      }
    }
  },
  mounted () {
    this.getEntry()
    this.getGlobalContact()
  },
  methods: {
    getEntry () {
      axios
        .get('api/contact.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    },
    getGlobalContact () {
      axios
        .get('api/globalContact.json')
        .then(response => {
          this.globalContact = response.data
        })
    },
    postForm () {
      const vm = this
      axios.post('/actions/sprout-forms/entries/save-entry', qs.stringify({
        handle: this.form.handle,
        fields: {
          firstName: this.form.name.first,
          lastName: this.form.name.last,
          email: this.form.email,
          phone: this.form.phone,
          message: this.form.message,
          receiveNewsletter: this.form.receiveNewsletter
        }
      }))
        .then(function (response) {
          console.log(response)
          if (vm.form.receiveNewsletter) {
            axios.post('//taiko.us18.list-manage.com/subscribe/post-json?u=e36297c050676c3a7178a17c7&amp;id=5715e58c82&c=?', qs.stringify({
              EMAIL: vm.form.email,
              FNAME: vm.form.name.first,
              LNAME: vm.form.name.last,
              PHONE: vm.form.phone
            }))
          }
          vm.formSubmitted = true
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue